import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { configApiRef, microsoftAuthApiRef, useApi } from '@backstage/core-plugin-api';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { navModule } from './modules/nav';

const signInPage = SignInPageBlueprint.make({
    params: {
        loader: async () => props => {
            const configApi = useApi(configApiRef);

            if (configApi.getString('auth.environment') === 'development') {
                return (
                    <SignInPage
                        {...props}
                        providers={[
                            'guest',
                            {
                                id: 'microsoft-auth-provider',
                                title: 'Microsoft',
                                message: 'Sign in using Microsoft',
                                apiRef: microsoftAuthApiRef,
                            }
                        ]}
                    />
                );
            }

            return (
                <SignInPage
                    {...props}
                    provider={{
                        id: 'microsoft-auth-provider',
                        title: 'Microsoft',
                        message: 'Sign in using Microsoft',
                        apiRef: microsoftAuthApiRef,
                    }}
                />
            );
        },
    },
});

export default createApp({
    features: [
        catalogPlugin,
        scaffolderPlugin,
        navModule,
        createFrontendModule({
            pluginId: 'app',
            extensions: [signInPage]
        })
    ],
});
